/**
 * Utilitários para tornar contato/endereço acionáveis (item 3.1 do lote 3).
 *
 * - `telHref`: número saneado para dial.
 * - `waHref`: WhatsApp com DDI Brasil (55) quando o número tiver DDD.
 * - `mailHref`: mailto padrão.
 * - `mapsHref`: URL universal do Google Maps (funciona em iOS e Android).
 */
export function digitsOnly(v) {
  return (v || "").toString().replace(/\D/g, "");
}

export function telHref(phone) {
  const d = digitsOnly(phone);
  if (!d) return null;
  return `tel:${d}`;
}

export function waHref(phone) {
  const d = digitsOnly(phone);
  if (!d) return null;
  // Se já vier com 55 ou tiver mais de 10 dígitos (DDD+numero) usa como está;
  // caso contrário prepende 55.
  const withCountry = d.startsWith("55") ? d : `55${d}`;
  return `https://wa.me/${withCountry}`;
}

export function mailHref(email) {
  if (!email || !String(email).includes("@")) return null;
  return `mailto:${email}`;
}

export function mapsHref({ logradouro, numero, bairro, cidade, estado, cep } = {}) {
  const parts = [logradouro, numero, bairro, cidade, estado, cep].filter(Boolean).map((p) => String(p).trim());
  if (!parts.length) return null;
  const q = encodeURIComponent(parts.join(", "));
  return `https://www.google.com/maps/search/?api=1&query=${q}`;
}
